var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.41 9.41L10.58 0.58C10.21 0.21 9.7 0 9.17 0H2C0.9 0 0 0.9 0 2V9.17C0 9.7 0.21 10.21 0.59 10.58L9.42 19.41C10.2 20.19 11.47 20.19 12.25 19.41L19.42 12.24C20.2 11.46 20.2 10.2 19.41 9.41ZM4.5 6C3.67 6 3 5.33 3 4.5C3 3.67 3.67 3 4.5 3C5.33 3 6 3.67 6 4.5C6 5.33 5.33 6 4.5 6Z",
    fill: "#81909E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgList);
export default __webpack_public_path__ + "static/media/List.3b200913b46b9b95682366f31babe2ce.svg";
export { ForwardRef as ReactComponent };